export function modifiedPlanTypeName(planTypeId: string) {
    let type;

    switch (planTypeId) {
        case '1':
            type = 'Basic';
            break;
        case '2':
            type = 'Coaching';
            break;
        default:
            type = '';
            break;
    }

    return type;
}

export const validPhoneNumber = (phoneNumber: string) => {
    const reg = /^\d{10}$/;
    return reg.test(phoneNumber);
};

export const validZipCode = (zipCode: string) => {
    const reg = /^\d{5}$/;
    return reg.test(zipCode);
};

/**
 * @function transformPhoneForAPI
 * @returns String
 * @description Function return phone number
 *
 * valid phone number must be of the format (xxx)(xxx)(xxxx) - 10 digits
 */
export const transformPhoneForAPI = (ApiPhoneNumber: string) => {
    const phone = ApiPhoneNumber.replaceAll('-', '');
    let phoneForApi;
    if (phone?.length <= 3) {
        phoneForApi = phone?.substring(0, 3);
    } else if (phone?.length <= 6) {
        phoneForApi = `${phone?.substring(0, 3)}-${phone?.substring(3, 6)}`;
    } else {
        phoneForApi = `${phone?.substring(0, 3)}-${phone?.substring(3, 6)}-${phone?.substring(6)}`;
    }
    return phoneForApi;
};

export function trimFormData(formData: any, formDataType = 'object') {
    const data = formData;
    if (formDataType === 'array') {
        data.forEach(function (dataObj: any) {
            const newDataObj = dataObj;
            Object.keys(newDataObj).forEach(function (key: any) {
                if (typeof newDataObj[key] === 'string') newDataObj[key] = newDataObj[key].trim();
            });
        });
    } else {
        Object.keys(data).forEach(function (key: any) {
            if (typeof data[key] === 'string') data[key] = data[key].trim();
        });
    }

    return data;
}

export function showLoaderAfterTimeout(setLoader: (val: boolean) => void) {
    setTimeout(() => {
        setLoader(false);
    }, 500);
}

export default {
    modifiedPlanTypeName,
    validPhoneNumber,
    validZipCode,
    transformPhoneForAPI,
    trimFormData,
    showLoaderAfterTimeout,
};
